import { IDeviceInfo } from './card';
import { IMultiEnabled, INameObjectN } from './index';

export enum SubscriberType {
    ACTIVE = 'active',
    PENDING = 'pending',
    PRE_ACTIVE = 'pre_active',
    READY = 'ready',
    SUSPENDED = 'suspended',
    TERMINATED = 'terminated',
    UNKNOWN = 'unknown',
    // ------------ CardSubscriberType ------------
    ACTIVE_THIS_MONTH = 'active_this_month',
    LIVE = 'live',
    UNMANAGED = 'unmanaged',
}

export type ISubscriberInfo = {
    id: string;
    activeThisMonth?: boolean;
    cardId?: string;
    cardName?: string;
    companies?: INameObjectN[];
    deviceInfo?: IDeviceInfo;
    features?: IMultiEnabled;
    firstSeen?: string;
    iccId?: string;
    imsi?: string;
    lastSeen?: string;
    msisdn?: string;
    onPremMigrated?: boolean;
    operatorId?: string;
    operatorName?: string;
    statuses?: string[];
};

export type ISubscriberAPI = {
    subscriber: {
        id: string;
        active_this_month: boolean;
        card_id: string;
        card_name: string;
        companies?: INameObjectN[];
        device_name: string;
        device_type: string;
        features?: IMultiEnabled;
        first_seen: string;
        iccid: string;
        imsi: string;
        last_seen: string;
        msisdn: string;
        on_prem_migrated: boolean;
        operator_id: string;
        operator_name: string;
        statuses: string[];
    };
};
